import React from "react";
import PropTypes from "prop-types";
import "../css/components/Icon.css";

export default class Icon extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    modifier: PropTypes.string,
    icon: PropTypes.string.isRequired,
  };
  /**
   * @constructor
   * @param {Object} props
   */
  constructor(props) {
    super(props);
    this.className = "Icon";
    if (props.modifier) {
      this.className += `--${props.modifier}`;
    }
  }
  render() {
    return <span data-icon={this.props.icon} className={this.className} />;
  }
}



// WEBPACK FOOTER //
// ./src/components/Icon.js